<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="cover cover-rw Cover-rw" epub:type="cover" style="text-align:center;">
<p style="margin:0.00em; text-align:center;"><img alt="Cover" src="images/9780316338899.jpg" style="height: 100%;"/></p></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?6d253553